import { useParams } from "react-router-dom";
import styled from "styled-components";
import { AppNoInfo, AppRemixIcon } from "@/layout/AppComponents";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../layout/components/helpers/Translator";
import AppLink from "../../../routing/helpers/AppLink";
import routes from "./moduleComsaRoutes";
import BreadcrumbHandler from "../../../layout/components/breadcrumb/BreadcrumbHandler";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { axiosPath } from "@/routing/helpers/router";
import _ from "lodash";

const ModuleComsaReportHomeScreen = () => {
  const { moduleBridgeHex, subModuleBridgeHex, plantHex } = useParams();
  const [moduleData, setModuleData] = useState();

  // > LOAD MODULE DATA //
  const loadModuleData = useCallback(async () => {
    await axios
      .post(axiosPath("api_r_user_module_comsaReports_getModuleData"), {
        moduleBridgeHex,
        subModuleBridgeHex,
        plantHex,
      })
      .then((response) => setModuleData(response.data));
  }, [moduleBridgeHex, subModuleBridgeHex, plantHex]);

  useEffect(() => {
    loadModuleData();
  }, []);
  // > LOAD MODULE DATA //

  if (!moduleData) return <AppNoInfo />;

  return (
    <div className="relative m_sr p-3">
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: `${
                    moduleData.plantName
                  } - ${ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name="evaluation"
                    />
                  )}`,
                  route: {
                    name: "user_module_legalCompliance_evaluation",
                    params: {
                      moduleBridgeHex,
                      plantHex,
                      page: 1,
                      filtersHex: 0,
                    },
                  },
                },
                {
                  name: `${ReactDOMServer.renderToString(<Translator file="module-comsaReports" name="indicators" />)}`,
                },
              ]
            : [{ name: "..." }]
        }
      />
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">
            <Translator file="module-comsaReports" name="indicators" />
          </h1>
        </div>
      </div>
      <div className="row">
        {routes.map((r, index) => {
          return (
            Object.keys(moduleData.indicators).includes(r.type) && (
              <div key={index} className="col-sm-4 col-lg-3">
                <AppLink
                  path={r.routeName}
                  params={{
                    moduleBridgeHex: moduleBridgeHex,
                    subModuleBridgeHex: subModuleBridgeHex,
                    plantHex: plantHex,
                  }}
                  className="card text-decoration-none mb-4"
                >
                  <ReportButton
                    className="card-body text-center pointer text-white"
                    bgColor={r.color}
                  >
                    <AppRemixIcon icon={r.icon} size={30} />
                    <div className="p-2">
                      <h5 className="text-white">
                        <Translator file="module-comsaReports" name={r.title} />
                      </h5>
                    </div>
                  </ReportButton>
                </AppLink>
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

export default ModuleComsaReportHomeScreen;

const ReportButton = styled.div`
  background-color: ${(props) => props.bgColor};
`;
